import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { KpiNotificationSettings } from './kpi-notification-settings.model';
import { KpiNotificationActions, KpiNotificationReducer, KpiNotificationSelectors } from './state';

@Injectable({
    providedIn: 'root',
})
export class KpiNotificationSettingsFacade {
    readonly isLoaded$ = this.store$.select(KpiNotificationSelectors.getLoaded);
    readonly kpiNotificationSettings$ = this.store$.select(
        KpiNotificationSelectors.getKpiNotificationSettings,
    );

    constructor(private readonly store$: Store<KpiNotificationReducer.State>) {}

    updateKpiSettings(reportId: string) {
        this.store$.dispatch(KpiNotificationActions.updateKpiSettings({ reportId }));
    }

    saveKpiNotificationSettings(reportId: string, kpiNotificationSettings: KpiNotificationSettings) {
        this.store$.dispatch(
            KpiNotificationActions.saveKpiNotificationSettings({ reportId, kpiNotificationSettings }),
        );
    }
}
